import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center text-xl black-title font-semibold" }, "Send NTF")
], -1)
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title w-16" }, "Assets")
], -1)
const _hoisted_5 = { class: "flex space-x-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title w-16" }, "Item ID")
], -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-col space-y-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-center text-xl font-semibold my-4" }, "To", -1)
const _hoisted_10 = { class: "flex space-x-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title w-20" }, "Account ID")
], -1)
const _hoisted_12 = { class: "flex space-x-8 items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "black-title w-16" }, "Remark", -1)
const _hoisted_14 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_caret_down_filled = _resolveComponent("caret-down-filled")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "",
    placement: _ctx.placement,
    visible: _ctx.visible,
    height: "75%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_select, {
            value: _ctx.level1Value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.level1Value) = $event)),
            class: "w-60 a-select",
            options: _ctx.ASSETS_LIST,
            onChange: _ctx.handleChange
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_component_caret_down_filled)
            ]),
            _: 1
          }, 8, ["value", "options", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("img", {
            src: _ctx.itemImageUrl != undefined ? _ctx.itemImageUrl : _ctx.DEFAULT_IMG,
            class: "w-10 h-10 -mt-1"
          }, null, 8, _hoisted_7),
          _createVNode(_component_a_select, {
            value: _ctx.level2Value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.level2Value) = $event)),
            class: "w-48",
            options: _ctx.list,
            loading: _ctx.loading,
            "field-names": { label: 'itemId', value: 'itemId' },
            onChange: _ctx.getItemUrl
          }, {
            suffixIcon: _withCtx(() => [
              _createVNode(_component_caret_down_filled)
            ]),
            _: 1
          }, 8, ["value", "options", "loading", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_a_select, {
              value: _ctx.accountIdValue,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountIdValue) = $event)),
              "show-search": "",
              class: "w-60 a-select",
              allowClear: "",
              options: _ctx.contactsList,
              filterOption: _ctx.filterOption,
              onFocus: _ctx.focus
            }, {
              suffixIcon: _withCtx(() => [
                _createVNode(_component_caret_down_filled)
              ]),
              _: 1
            }, 8, ["value", "options", "filterOption", "onFocus"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_a_input, {
              class: "a-input",
              style: {"width":"242px"},
              value: _ctx.remarkValue,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remarkValue) = $event)),
              placeholder: "Option"
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 0,
              message: _ctx.isErrorMessage,
              type: "error"
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            class: "next-button cursor-pointer p-2 w-32 text-center rounded-full",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSendClick && _ctx.handleSendClick(...args)))
          }, "Send")
        ])
      ])
    ]),
    _: 1
  }, 8, ["placement", "visible"]))
}